import { render, staticRenderFns } from "./OrderReplacement.vue?vue&type=template&id=44824e50&scoped=true"
import script from "./OrderReplacement.vue?vue&type=script&lang=ts"
export * from "./OrderReplacement.vue?vue&type=script&lang=ts"
import style0 from "./OrderReplacement.vue?vue&type=style&index=0&id=44824e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44824e50",
  null
  
)

export default component.exports